import Swal from "sweetalert2";
const apibtoast = {
  data() {
    return {};
  },
  methods: {
    async Post(Servis, Data, Mesaj) {
      return this.ActionsPost({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.PostPozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return res.Data;
          } else {
            this.$toast.error(this.$t("ToasMessage.PostNegatif"));
            return false;
          }
        }
      );
    },
    async Post2(Servis, Data) {
      return this.ActionsPost({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
        
            this.$toast.success(this.$t(res.Message));
            this.Get();
            return true;
          } else {
            this.$toast.error(this.$t(res.Message));
            return false;
          }
        }
      );
    },
    async Update(Servis, Data, Mesaj) {
      return this.ActionsPut({ Service: Servis, Data: Data }).then((res) => {
        if (res.Succeeded == true) {
          if (Mesaj != false) {
            if (Mesaj === undefined || Mesaj === null) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.success(Mesaj);
            }
          }
          this.Get();
          return true;
        } else {
          this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
          return false;
        }
      });
    },
    async UpdateIdsiz(Servis, Data, Mesaj) {
      return this.ActionsPutIdsiz({ Service: Servis, Data: Data }).then((res) => {
        if (res.Succeeded == true) {
          if (Mesaj != false) {
            if (Mesaj === undefined || Mesaj === null) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.success(Mesaj);
            }
          }
          this.Get();
          return true;
        } else {
          this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
          return false;
        }
      });
    },
    async UpdateList(Servis, Data, Mesaj) {
      return this.ActionsPutList({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return true;
          } else {
            this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
            return false;
          }
        }
      );
    },
    
    async PostList(Servis, Data, Mesaj) {
      return this.ActionsPostList({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return true;
          } else {
            this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
            return false;
          }
        }
      );
    },
    async Delete(Servis, StrId, Mesaj) {
      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          this.ActionsDelete({ Service: Servis, Id: StrId }).then((res) => {
            if (res.Succeeded == true) {
              this.Get();
              if (Mesaj != false) {
                if (Mesaj === undefined || Mesaj === null) {
                  this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
                } else {
                  this.$toast.success(Mesaj);
                }
              }
            } else {
              this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
            }
          });
        }
      });
    },
    async BildirimTanimMail(Mesajturukod, PersonelId, Basvuru){
      this.ActionsSingleGet({ Service: "opersonel", Id: PersonelId }).then(
        (resp) => {  
          if (resp.Succeeded == true) {
            
      this.ActionsFilterGet({
        Service: "tsvbildirimtanim",
        FullData: true,
        Filter: "&Mesajturukod=" + Mesajturukod,
      }).then((res) => {
        if(res.Data[0].Aktif == true){
          var BasvuruNo = Basvuru.Numara;
          let MailData = {
            Message:  Basvuru ? (res.Data[0].Icerik + ' Basvuru Numarası: ' + BasvuruNo.toString()) : res.Data[0].Icerik ,
            Recievermailadress: resp.Data.Eposta,
          };
          this.Post("TsvBildirimTanim/SendInvite", MailData, false).then((respon) => {
            if (respon) {
              this.$emit("TableUpdate");
              
            }
          });
        }
          }
);
        }
}
);
    }
  },
};

export default apibtoast;
